import ListingCardHorizontal from '@global/ListingCard/Horizontal'
import { sortAuctions, sortInspections, sortSetDate } from '@lib/helpers/search'
import { listSearchPageType } from '@lib/variables'
import { useEffect } from 'react'
import NoResults from '../NoResults'

const SearchResultDateGroup = ({ items, page_type, onPropertyClick }) => {
  let data = []
  if (page_type == listSearchPageType.SEARCH_TYPE_AUCTION) {
    data = sortAuctions(items)
  } else if (page_type == listSearchPageType.SEARCH_TYPE_INSPECTION) {
    data = sortInspections(items)
  } else if (page_type == listSearchPageType.SEARCH_TYPE_SALEDATE) {
    data = sortSetDate(items)
  }

  const handleViewDetail = (propertyId) => {
    if (onPropertyClick) {
      const propertyIdNumber = propertyId.replace('property-', '')
      onPropertyClick(propertyIdNumber)
      return
    }

    const element = document.getElementById(propertyId)
    if (element) {
      const rect = element.getBoundingClientRect()
      sessionStorage.setItem('searchViewportOffset', rect.top)
      sessionStorage.setItem('searchLastViewedItem', propertyId)
    }
  }

  useEffect(() => {
    if (onPropertyClick) return

    const lastViewedItem = sessionStorage.getItem('searchLastViewedItem')
    if (items?.findIndex((it) => `property-${it.id}` === lastViewedItem) === -1)
      return

    const savedViewportOffset = parseInt(
      sessionStorage.getItem('searchViewportOffset') || '0',
      10
    )

    if (lastViewedItem) {
      setTimeout(() => {
        const element = document.getElementById(lastViewedItem)
        if (element) {
          const rect = element.getBoundingClientRect()
          const offsetDiff = rect.top - savedViewportOffset
          window.scrollTo({
            top: window.pageYOffset + offsetDiff,
            behavior: 'auto',
          })
          sessionStorage.removeItem('searchViewportOffset')
          sessionStorage.removeItem('searchLastViewedItem')
        }
      }, 100)
    }
  }, [items, onPropertyClick])

  return (
    <div>
      {items.length > 0 ? (
        items.map((item, i) => (
          <ListingCardHorizontal
            {...ListingCardHorizontal.ApiDataToProps(item)}
            key={`listing-${i}`}
            showType={page_type}
            isAuctionView={page_type == listSearchPageType.SEARCH_TYPE_AUCTION}
            onViewDetail={handleViewDetail}
          />
        ))
      ) : (
        <NoResults isAuction pageType={page_type} />
      )}
    </div>
  )
}

SearchResultDateGroup.defaultProps = {
  items: [],
  metaData: {},
}

export default SearchResultDateGroup
